export const OPEN_MI_DETAILS_MODAL = 'OPEN_MI_DETAILS_MODAL';
export const CLOSE_MI_DETAILS_MODAL = 'CLOSE_MI_DETAILS_MODAL';

function openMiDetailsModal() {
  return {
    type: OPEN_MI_DETAILS_MODAL,
    isMiDetailsModalShown: true
  };
}

function closeMiDetailsModal() {
  return {
    type: CLOSE_MI_DETAILS_MODAL,
    isMiDetailsModalShown: false
  };
}

export function showMiDetailsModal() {
  return (dispatch) => {
    dispatch(openMiDetailsModal());
  };
}

export function hideMiDetailsModal() {
  return (dispatch) => {
    dispatch(closeMiDetailsModal());
  };
}
